var path = '/templates/zenclerk_s/common/product_changes/product_changes_page.html';
var html = "<div class=\"container container-limited product-changes\"><div class=row><div class=col-xs-12><ng-include src=\"'/templates/zenclerk_s/common/product_changes/product_changes.html'\"></ng-include></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/common/product_changes/product_changes_page.html
// module id = 1315
// module chunks = 0